import React from 'react';
import { FaUser } from 'react-icons/fa';

// studentId.profile.ugBatchId comes back from the backend as a plain
// ObjectId string (flat .select(), not a nested populate — see e.g.
// server/routes/ugReflectionRoutes.js's /all route) so this just does a
// local lookup against the batch list already fetched by the shell.
export const getBatchLabel = (student, ugBatches) => {
  const batchId = student?.profile?.ugBatchId?._id || student?.profile?.ugBatchId;
  if (!batchId) return null;
  const batch = (ugBatches || []).find(b => b._id === batchId.toString());
  return batch?.batchLabel || null;
};

// Same visual pattern as PG's ViewLogbooks.js .student-info/.student-avatar
// header (see that file + ViewLogbooks.css) — student identity is always
// the first thing shown on an entry card, not something you click to see.
const StudentHeader = ({ student, ugBatches, statusBadge }) => {
  const batchLabel = getBatchLabel(student, ugBatches);
  return (
    <div className="ugtr-entry-header">
      <div className="ugtr-student-info">
        <div className="ugtr-student-avatar"><FaUser /></div>
        <div className="ugtr-student-details">
          <h4>
            {student?.profile?.firstName} {student?.profile?.lastName}
            {batchLabel && <span className="ugtr-student-batch-tag">{batchLabel}</span>}
          </h4>
          {student?.email && <span className="ugtr-student-email">{student.email}</span>}
        </div>
      </div>
      {statusBadge}
    </div>
  );
};

export default StudentHeader;
